import unitFetcher from "./unitFetcher";

const holder = {
  closePropertySelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false, pageNumber: 1 });
      document.removeEventListener("mousedown", holder.closePropertySelector)
    }
  }
};


let timer;

const debounce = function (fn, d) {
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(fn, d);
}

const searchUnits = async (searchTerm, unitFetcher, selectedPropertyId, internalStateSetter) => {
  debounce(async () => {
    const result = await unitFetcher.fetchResidents({ id: searchTerm });
    let units = selectedPropertyId ? (result.data ?? []).filter(u => u.property_id === selectedPropertyId) : (result.data ?? []);
    internalStateSetter({ loadingResidents: false, units });
    return true;
  }, 1000);
}

export default {
  'ResidentSelector.HeaderWrapper': ({ isOpen, containerRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    internalStateSetter({ isOpen: !isOpen, pageNumber: 1 });
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closePropertySelector);
    } else {
      document.addEventListener("mousedown", holder.closePropertySelector);
    }
  },
  'ResidentSelector.HeaderWrapper.LeftSideWrapper.Wrapper.SearchInput': async ({ value, selectedPropertyId }, _, internalStateSetter) => {
    if (value.length > 0) {
      internalStateSetter({ loadingResidents: true, searchTerm: value });
      await searchUnits(value, unitFetcher, selectedPropertyId, internalStateSetter);
    }
    else {
      internalStateSetter({ units: [], searchTerm: value })
    }
  },
  'ResidentSelector.Body.Unit': ({ unit, residentList }, outlet, internalStateSetter) => {
    outlet({ residentList: [...residentList, unit] })
    internalStateSetter('isOpen', false);
    internalStateSetter('searchTerm', '');
  },
  'ResidentSelector.HeaderWrapper.LeftSideWrapper.Wrapper.SelectedButton': ({ resident, residentList }, outlet) => {
    outlet({ residentList: residentList.filter(r => r.id !== resident.id) });
  },
  'ResidentSelector.Body.LoadMore': ({ pageNumber }, _, internalStateSetter) => {
    internalStateSetter({ pageNumber: pageNumber + 1 })
  },
  'ResidentSelector.HeaderWrapper.AddUnit': ({ isOpen, isAddUnitButtonExternalFunction, residentList }, outlet, internalStateSetter) => {
    if (isAddUnitButtonExternalFunction) {
      outlet({ action: 'add_unit_button', residentList })
    } else {
      internalStateSetter({ isOpen: !isOpen })
    }
  },
}